// extracted by mini-css-extract-plugin
module.exports = {"LoadingComponent":"styles_LoadingComponent__Y_EJW","spinner":"styles_spinner__OXQLH","spinnerContainer":"styles_spinnerContainer__hO5L1"};